// extracted by mini-css-extract-plugin
module.exports = {"content":"StepPayment_content__3E4f6","wrapper":"StepPayment_wrapper__1QAS1"};